module.exports = function() {
  return new Worker("/cvat-static/" + "download.worker.a41c65bae428e604d1fe.js");
};